import React, { useState } from 'react';
import MenuRight from './MenuRight';
import MenuBottom from './MenuBottom';
import LeftContent from './LeftContent';
import CenterContent from './CenterContent';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';

function Dashboard({ changeActiveComponent }) {
  const [tokenAddress, setTokenAddress] = useState('');

  const handleActiveNftChange = (activeNft) => {
    setTokenAddress(activeNft); // Correctly updating the state
  };

  return (
    <section id="dashboard">
      <div className="platform-container">
      <LeftContent changeActiveComponent={changeActiveComponent} tokenAddress={tokenAddress} />
        <CenterContent onActiveNftChange={handleActiveNftChange} changeActiveComponent={changeActiveComponent} />
      </div>
    </section>
  );
}

export default Dashboard;